import React, { useState, useEffect } from 'react';

const GradientGauge = ({
  min = 0,
  max = 100,
  current = 50,
  backgroundColor = '#D3D3D3',
  barColorGradientStart = '#00FF00',
  barColorGradientEnd = '#FF0000',
  height = '20px',
  borderRadius = '4px',
  unit = '',
  textColor = '#000'
}) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const newPercentage = ((current - min) / (max - min)) * 100;
    setPercentage(Math.min(Math.max(newPercentage, 0), 100));
  }, [current, min, max]);

  return (
    <div style={{ width: '100%', height, position: 'relative', padding: '0 0 20px 0' }}>
      <div
        style={{
          width: '100%',
          height: '100%',
          background: `linear-gradient(to right, ${barColorGradientStart}, ${barColorGradientEnd})`,
          borderRadius: borderRadius,
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            width: `${100 - percentage}%`,
            height: '100%',
            backgroundColor: backgroundColor,
            position: 'absolute',
            right: 0,
            transition: 'width 500ms'
          }}
        ></div>
      </div>
      <div style={{ position: 'absolute', width: '100%', textAlign: 'center', color: textColor, fontWeight: "bold" }}>
        {current} {unit}
      </div>
      <div style={{ position: 'absolute', left: 0, color: textColor }}>
        {min} {unit}
      </div>
      <div style={{ position: 'absolute', right: 0, color: textColor }}>
        {max} {unit}
      </div>
    </div>
  );
};

export default GradientGauge;
